import React, { useState, useEffect } from 'react'
import "./CustomDatatableTransmission.css";
import { FaPencilAlt, FaRegCommentDots } from "react-icons/fa";
import { HiEye } from "react-icons/hi";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import Pagination from '../Pagination/Pagination';
import { customFormatDate, customFormatHour } from '../../utils/utils';



const CustomDatatableTransmission = (props) => {

    const { columns, 
            changePage, 
            pageCount, 
            pageNumber, 
            perPage, 
            showEditTransmission, 
            handleCloseEditTransmission, handleShowEditTransmission, data } = props;
    let months= ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

    // const [pageNumber, setPageNumber] = useState(0);
    // const itemsPerPage = 5;
    // const pagesVisited = pageNumber * itemsPerPage;

    const navigate = useNavigate();

    // const changePage = ({ selected }) => {
        // setPageNumber(selected)
    // }

    // const pageCount = Math.ceil(data?.length / itemsPerPage)


    return (
        <>
        {/* Start */}
        <div className="table-responsive ">
            <table className="table table-striped dataTable w-100">
                <thead className="">
                    <tr className="" role={"row"}>
                        {columns && columns.map((item, index) =>
                            <th key={index+"wcdtc"} className={item.label == "#" ? "text-left pl-4" :"text-left pl-3"} aria-sort="ascending" >
                                {item.label}</th>
                        )}
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length != 0 ? data?.map((item, index) =>
                        <tr key={`transmission-${index}`}>
                            
                            <td className="text-left pl-4">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                            <td className="text-left pl-3">
                                            {/* {parseInt(item.mois)} */}
                                            {months[parseInt(item.mois) - 1 ]}{" "}{item.annee}

                                        </td>
                                        <td className="text-left pl-3">
                                            {customFormatDate(item.created_at)}{" à "}{ customFormatHour(item.created_at)}
                                            {/* {(item.created_at)} */}
                                        </td>
                                        <td className="text-left pl-3">
                                        <span className={item.statut == "Transmis" ? "badge badge-success" : item.statut == "Transmis en retard" ? "badge badge-warning" : "badge badge-danger"}>{item.statut}</span>
                                        </td>
                            
                           
                           
                            <td className=" text-center">
                                <HiEye 
                                onClick={() => navigate(`/transmission/${item.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                                <FaRegCommentDots 
                                onClick={() => navigate(`/transmission-chat/${item.id}`)} 
                                title="Commenter" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                            </td>
                            {/* <button title="Consulter" className="btn btn-success btn-sm mr-1" onClick={() => handleShowEditTransmission(item.id)}> <HiEye /> </button> */}
                        </tr>
                    ) : <h1 className="ok"></h1>}
                </tbody>
            </table>
            <Pagination pageCount={pageCount} changePage={changePage} />
        </div>
        {/* End */}
  
        </>
    )
}

export default CustomDatatableTransmission